import createStore from "APP_ROOT/createStore";
import { USER } from "MODULES/users/constants";
import { SETTINGS } from "APP_ROOT/constants";

export default function useCurrentUser() {
  return createStore()
    .getState()
    .session.get(USER)
    .toJS();
}

export function useSettings() {
  return createStore()
    .getState()
    .session.get(SETTINGS)
    .toJS();
}

export const defaultStoreLocation = currentUser =>
  currentUser.tenant.locations_count === 1
    ? currentUser.locations[0].id
    : undefined;



// WEBPACK FOOTER //
// ./app/hooks/useCurrentUser.js